import { Breadcrumb, Button, Col, Form, Input, Row, Select, Steps } from "antd";
import Loading from "../../../../auxiliary/loader/loading";
import { _adr } from "../../../../../address";
import { Content } from "antd/es/layout/layout";
import { HomeOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useAPIPublic, useDealer } from "../../../../../tools/api";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { clearFormData, simcardPurchase } from "../../../../../reducer/serviceReducer";
import Profile from "../../profile/profile";

const CoSimKit = () => {
	const [t] = useTranslation("global");
	const [frmValid] = Form.useForm();
	const location = useLocation();
	const { querySimSwapReason } = useAPIPublic();
	const { checkKitNOForSW, reserveKitNo } = useDealer();

	const nav = useNavigate();
	const formData = useSelector((state) => state?.from?.swchange);
	const dispatch = useDispatch();

	const [coKit, setCoKit] = useState({
		purchase: location?.state || null,
		isLoading: false,
	});

	useEffect(() => {
		if (coKit.purchase) {
			dispatch(
				simcardPurchase({
					swchange: { purchase: coKit.purchase },
				}),
			);
		} else {
			if (formData) {
				frmValid.setFieldValue("kitNo", formData?.newKit);
				setCoKit((kit) => ({ ...kit, purchase: formData.purchase }));
			}
		}
	}, [coKit.purchase]);

	const handleSubmit = async () => {
		try {
			setCoKit((kit) => ({ ...kit, isLoading: true }));
			let valid = await frmValid.validateFields();
			if (valid) {
				///cal service check kit
				let payload = {
					kitNo: valid.kitNo,
					msisdn: coKit.purchase.inT_MSISDN,
				};
				let res = await checkKitNOForSW(payload);
				if (res && !res.HasError) {
					//call service reserv kit
					payload = {
						KitNo: valid.kitNo,
					};
					res = await reserveKitNo(payload);
					if (res && !res.HasError) {
						dispatch(
							simcardPurchase({
								swchange: {
									purchase: coKit?.purchase,
									newKit: valid.kitNo,
								},
							}),
						);
						nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.SimSwap.Index + _adr.Corporate.SimSwap.PreFactor);
					}
				}
			}
			setCoKit((kit) => ({ ...kit, isLoading: false }));
		} catch (error) {
			console.error(error);
			setCoKit((kit) => ({ ...kit, isLoading: false }));
		}
	};
	return (
		<>
			<div className="container-main container-cs">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardreplacement.legal.title") }]}
					/>
					<div className="title-page">
						<h3>{t("simcardreplacement.legal.title")}</h3>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main cs-container">
						<div className="g-format-page">
							<Profile Profile={coKit?.purchase} state />
							<br />
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={1}
											items={[
												{
													title: "احراز هویت",
												},
												{
													title: "مشخصات سیم‌کارت",
												},
												{
													title: "پیش فاکتور",
												},
											]}
										/>
									</div>
								</div>
								<div className="holder-new-kit">
									<Form form={frmValid} layout="vertical">
										<Row>
											<Col xl={8} lg={10} md={12} sm={24} xs={24}>
												<Form.Item
													className="input-normal"
													style={{ padding: "0" }}
													label="شماره کیت جدید"
													name="kitNo"
													rules={[
														{
															required: true,
															message: t("validation.required"),
														},
														{
															pattern: new RegExp(/^[0-9]{9}$/),
															message: t("validation.regex"),
														},
													]}>
													<Input dir="ltr" autoComplete="off" placeholder="شماره کیت جدید را وارد کنید" inputMode="numeric" maxLength={9} showCount />
												</Form.Item>
											</Col>
										</Row>
									</Form>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button className="btn-normal btn-aptel" htmlType="submit" type="primary" danger onClick={handleSubmit}>
										مرحله بعد
									</Button>
									<Button
										className="btn-normal"
										onClick={() => {
											nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.Search);
										}}>
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>

			<Loading isOpen={coKit.isLoading} />
		</>
	);
};

export default CoSimKit;
